// src/client/lib/query-client.ts
//
// Phase B T2a: TanStack Query client instance.
// 設定方針 (MVP):
//  - staleTime: 30 秒 (UI 操作中の不要 refetch を抑制)
//  - retry: 1 (エラー時の自動再試行は最小限、UX 優先)
//  - refetchOnWindowFocus: false (mobile / 現場 UX で過度な再取得を避ける)
//  - **runtime cache (offline / persist) は未対応** (mobile-pwa-policy §1-4 を Phase B+ で評価)
//
// 参照:
//  - docs/plans/phase-b-frontend-mvp-plan.md Q5
//  - docs/ux/mobile-pwa-ux-policy.md §1-4

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
